import { ICostCategory } from 'src/common/interfaces/cost-setup';

export const updateAllSubCategories = (list: ICostCategory[], categoryId: string, costCodesId: string | null) => {
  const updateCostCodesIdRecursively = (parentId: string) => {
    list.forEach((item) => {
      if (item.parentId === parentId && item.costCategoryId) {
        item.costCodesId = costCodesId;
        updateCostCodesIdRecursively(item.costCategoryId);
      }
    });
  };

  updateCostCodesIdRecursively(categoryId);
  return list;
};
